import router from "@/router";
import EventBus from "@/EventBus";
import { NOT_FOUND_PAGE_NAME } from "../router/pageNameConstants";

const catchErrors = (fn, msg = "Unable to load request") => {
  return fn().catch(() => {
    EventBus.$emit("AddNewNotification", msg, "error");
    return null;
  });
};

const notFound = fn => {
  return fn().catch(error => {
    if (error.response && error.response.status === 404) {
      router.replace({
        name: NOT_FOUND_PAGE_NAME,
        param: {}
      });
    }
  });
};

export { catchErrors, notFound };
